/* eslint-disable formatjs/no-literal-string-in-jsx */
import React from 'react'

import { ClaudeIcon, GitHubIcon } from '@slite/icons'

import type { Scenario } from './types'

const OUTDATED = `# Integrations

Last reviewed: {-January 2025-} {+June 2026+}

Slite connects to the tools your team already uses.

{-## CSV Import-}
{-Import existing documentation in bulk using a CSV file, including section-}
{-metadata, owners, and review dates from older help center exports.-}
{-Supports up to 500 rows per import.-}

## Slack
Receive doc update notifications in Slack and create docs from any message,
so support and product teams can turn recurring answers into trusted docs.

## GitHub
Link pull requests and issues directly inside docs.

## Zapier
Connect Slite to 5,000+ apps via Zapier.
`

const APPLIED = `# Integrations

Last reviewed: June 2026

Slite connects to the tools your team already uses.

## Slack
Receive doc update notifications in Slack and create docs from any message,
so support and product teams can turn recurring answers into trusted docs.

## GitHub
Link pull requests and issues directly inside docs.

## Zapier
Connect Slite to 5,000+ apps via Zapier.
`

export const githubScenario: Scenario = {
  id: 'github',
  buttonLabel: 'Agent-triggered review',
  initialDocId: 'integrations',
  signal: {
    icon: <ClaudeIcon size={16} />,
    label: 'Claude asks Slite to check release/3.4.0',
  },
  routine: {
    label: 'Comparing code changes with docs',
  },
  sourceSignal: {
    icon: <GitHubIcon size={16} />,
    label: 'PR #519 removes CSV Import from release/3.4.0',
  },
  finding: 'CSV Import was removed in release/3.4.0 but is still documented.',
  diff: {
    docId: 'integrations',
    outdatedContent: OUTDATED,
    appliedContent: APPLIED,
    pill: { kind: 'remove', text: 'CSV Import section' },
  },
  routeNote: 'Triggered by GitHub CI after the release branch merged.',
  reviewer: { name: 'Alex', cursorColor: 'var(--shade-00)' },
}
